<template>
    <div id="">
         <div class="container-fluid  bg-primary ">
            <div class="page-title">
              <div class="row">
                <div class="col-12">
                 <img class="img-fluid for_logo" src="../../../assets/images/logo/hcelogo.png"
                                    alt="looginpage">
                </div>
               
              </div>
            </div>
          </div>
          
      <TabQrScanner />
    </div>
  </template>
  
  <script>
  import TabQrScanner from '@/components/TabQrScanner.vue'
  
  export default { 
    components: {
      TabQrScanner
    }
  }
  </script>
  
  <style>
  /* Add any global styles if needed */
  </style>
  